import { useState } from 'react';

import { TPairingWarrior } from '~/../api/common.types';

import MatchupWarrior from './MatchupWarrior';

export default function Matchup({
  matchup,
  ownedWarriorIDs,
  right,
  isBracket,
  defaultActive,
}: {
  matchup: TPairingWarrior[];
  ownedWarriorIDs: number[] | undefined;
  right?: boolean;
  isBracket: boolean;
  defaultActive?: boolean;
}) {
  const [active, setActive] = useState(defaultActive || false);
  const [warriorOne, warriorTwo] = matchup;
  if (!warriorOne || !warriorTwo) return <></>;
  const isOwned =
    ownedWarriorIDs?.includes(warriorOne.id) ||
    ownedWarriorIDs?.includes(warriorTwo.id);
  return (
    <>
      {isBracket && <div className={`bracket__explainer ${right ? 'bracket__explainer--right' : ''}`}>{warriorOne.name} vs {warriorTwo.name}</div>}
      <div
        className={`tournament_matchup${
          isOwned ? ' tournament_matchup--owned' : ''
        }`}
        title={isBracket ? '': `${warriorOne.name} (${warriorOne.id}) vs ${warriorTwo.name} (${warriorTwo.id})`}
        onMouseEnter={() => setActive(true)}
        onMouseLeave={() => setActive(false)}
      >
        <MatchupWarrior
          warrior={warriorOne}
          active={active}
          facing="east"
          // if warriorOne.isWinner is undefined, means this is a paring, not a result
          stunned={warriorOne.isWinner === undefined ? false : !warriorOne.isWinner}
        />
        <MatchupWarrior
          warrior={warriorTwo}
          active={active}
          facing="west"
          // if warriorTwo.isWinner is undefined, means this is a paring, not a result
          stunned={warriorTwo.isWinner === undefined ? false : !warriorTwo.isWinner}
        />
      </div>
    </>
  );
}
